import { useContext } from "react";
import { ConfigStateContext } from "../../../Contexts/Configurations/context";
import {
	showBathrooms,
	showBedrooms,
	showRooms,
	showGuests,
	showM2,
} from "../../../Utils/Functions";

interface useTypologyTagProps {
	propertyType: Number,
	operationType: Number,
	isProject?: boolean,
	bedrooms?: number | number[],
	bathrooms?: number | number[],
	rooms?: number | number[]
}

interface useTypologyTagResponse {
	showBedrooms: Boolean,
	showBathrooms: Boolean,
	showRooms: Boolean,
	showGuests: Boolean,
	showM2: Boolean
}

type Hook = (useTypologyTagProps) => useTypologyTagResponse

const roomsPropertyTypeIds = [4, 9, 19, 5];

export const useTypologyTag: Hook = ({ propertyType, operationType, isProject = false, bedrooms, bathrooms, rooms }) => {
	const { country_code } = useContext(ConfigStateContext);
	const isRoomsPropertyType = roomsPropertyTypeIds.includes(Number(propertyType));

	return {
		showBedrooms: isProject
			? !isRoomsPropertyType
			: showBedrooms([propertyType], operationType, country_code, bedrooms),
		showBathrooms: isProject || showBathrooms([propertyType], country_code, bathrooms),
		showRooms: isProject
			? isRoomsPropertyType
			: showRooms([propertyType], country_code, rooms),
		showGuests: showGuests(operationType),
		showM2: showM2(operationType),
	};
}
